export default "__VITE_ASSET__dd5cbf13__"